import React from 'react'
import { Box } from '@mui/system'
import { Divider } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import LoadingButton from '@mui/lab/LoadingButton/LoadingButton'

interface Props {
  disabled?: boolean
  isLoading?: boolean
}

const SaveConfigurationButton: React.FC<Props> = ({ disabled, isLoading }) => {
  const { t } = useCustomTranslation()

  return (
    <>
      <Divider sx={{ marginX: -2, borderColor: 'grey.grey06', marginBottom: 2 }} />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <LoadingButton type={'submit'} variant={'contained'} disabled={disabled} loading={isLoading}>
          {t('common.save')}
        </LoadingButton>
      </Box>
    </>
  )
}

export default SaveConfigurationButton
